import { ExcludedPlatforms } from 'app/types/excludedPlatforms'

export const mapExcludedPlatforms = (excludedPlatforms: ExcludedPlatforms) => {
  return Object.keys(excludedPlatforms)
    .map((p) => (excludedPlatforms[p] ? p : null))
    .filter(Boolean)
}
